import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import { Box, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import React from 'react';
import { useMutation, useQuery } from 'react-query';
import IconButton from '../../../components/IconButton';
import { ICON_BUTTON_TYPE } from '../../../constants';
import { deleteDoctorApi, getDoctorApi, getUserDoctorContact, deleteUserDoctorContact } from '../../../utils/api';
import AddDoctorModal from './AddDoctorModal';
import TopBar from './TopBar';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

const DoctorContact = ({ user, recipient }) => {
  const { t } = useTranslation();
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [activeEditData, setActiveEditData] = React.useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { data, isLoading, refetch } = useQuery(
    ['getUserDoctorContact'],
    () =>
      recipient?._id
        ? getDoctorApi({ userId: user?._id, recipientId: recipient?._id })
        : getUserDoctorContact({ userId: user?._id }),
    {
      retry: false,
      cacheTime: 0,
    },
  );

  const deleteDoctorHandler = useMutation(recipient?._id ? deleteDoctorApi : deleteUserDoctorContact, {
    onSuccess: async ({ data }) => {
      refetch();
    },
    onError: (error) => {
      console.log('error =====> ', error);
    },
  });

  const handleDelete = (item) => {
    if (recipient?._id) {
      deleteDoctorHandler.mutate({ userId: user?._id, recipientId: recipient?._id, doctorId: item?._id });
    } else {
      deleteDoctorHandler.mutate({ userId: user?._id, doctorId: item?._id });
    }
  };

  const handleShowEdit = (item) => {
    setActiveEditData(item);
    setShowAddModal(true);
  };

  return (
    <Grid>
      <TopBar
        btnText={t('addDoctor')}
        onClick={() => {
          setShowAddModal(true);
          setActiveEditData(null);
        }}
      />

      {isLoading && (
        <Grid marginY={10} container justifyContent={'center'}>
          <CircularProgress size={40} style={{ color: '#26786a' }} />
        </Grid>
      )}

      {!isLoading && isEmpty(data?.data) && (
        <Typography variant="h5" textAlign="center">
          {t('noDoctorFound')}
        </Typography>
      )}

      {!isLoading &&
        !isEmpty(data?.data) &&
        data?.data.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: isMobile ? '90%' : '100%',
              gap: 2,
              p: 4,
              bgcolor: 'background.paper',
              marginBottom: isMobile ? '20px' : 0,
              borderRadius: 2,
              mt: 2,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    bgcolor: '#e6f2f0',
                    borderRadius: '50%',
                  }}
                >
                  <LocalHospitalIcon sx={{ color: '#26796b', fontSize: 20 }} />
                </Box>
                <Typography variant="h6" color="text.primary">
                  {item?.name}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <IconButton type={ICON_BUTTON_TYPE.edit} onClick={() => handleShowEdit(item)} />
                <IconButton type={ICON_BUTTON_TYPE.delete} onClick={() => handleDelete(item)} />
              </Box>
            </Box>
            <Divider />
            <Grid container sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  {t('phoneNumber')}
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {item?.phoneNo}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  {t('clinic')}
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {item?.clinic}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  {t('address')}
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {item?.address}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  {t('available')}
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {item?.availability}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        ))}
      <AddDoctorModal
        show={showAddModal}
        onClose={() => {
          setShowAddModal(false);
          setActiveEditData(null);
        }}
        recipient={recipient}
        refetch={refetch}
        activeEditData={activeEditData}
      />
    </Grid>
  );
};

export default DoctorContact;
